export const ApplicationBrand = {
    brandName: 'VE Sales Portal'
};

export const MenuItems = {
    "applicationItem": {
        "data": [
            {
                parentID: 1,
                item: [
                    {
                        itemTitle: "Sales Report (Salesforce)",
                        itemList: [
                            {
                                id: '1',
                                name: "Medical Doctors",
                                icon: "/Images/desk-customer.svg",
                                path: "/dashboards",
                                roleLevel: "0"
                            }
                        ]
                    }
                ]
            }
        ]
    }
};

export const ApplicationItems = {
    "applications": [
      {
        name: "Sales Analytics",
        icon: "/Images/graph-bar.svg",
        modules: [
          {
            id: 1,
            name: "Dashboard",
            icon: "/Images/dashboard.svg",
            roleLevel: "0",
            path: "/dashboards",
            children: [
              {
                menuHeader: "Sales Reports (Salesforce)"
              },
              {
                id: 1,
                name: "Medical Doctors",
                icon: "/Images/desk-customer.svg",
                roleLevel: "0",
                path: "/dashboards"
              }
            ]
          }
        ]
      }
    ]
  }